import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=36b78afe&scoped=true"
var script = {}
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=36b78afe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b78afe",
  null
  
)

export default component.exports